export const getOrderScooter = (state) => state.orderScooter
